import React from 'react';
import { withNamespaces } from 'react-i18next';
import T from 'prop-types';
import { Link } from 'react-static';

import getLocalizationLink from 'utils/getLocalizationLink';
import Logo from 'components/Logo';
import logoSvg from './logo.svg';
import './styles.scss';

const HeaderLogo = ({ logo, width, height, i18n }) => {
  const isSVG = typeof logo === 'object';
  const to = getLocalizationLink(i18n.language, '/');

  return (
    <Link className="header-logo" to={to} aria-label="liquid">
      <span className="header-logo__icon">
        {isSVG ? (
          <Logo logo={logo} width={width} height={height} />
        ) : (
          <img alt={logo} src={logo} width={width} height={height} />
        )}
      </span>
    </Link>
  );
};

HeaderLogo.defaultProps = {
  logo: logoSvg,
  width: 192,
  height: 32,
};

HeaderLogo.propTypes = {
  logo: T.oneOfType([T.shape({}), T.string]),
  width: T.number,
  height: T.number,
};

export default withNamespaces()(HeaderLogo);



// WEBPACK FOOTER //
// ../src/components/Header/Logo/index.jsx